<template>
  <div class="flex flex-col py-5 gap-1 px-4">
    <div v-for="(menuItem, index) in checkUserEmail" :key="index">
      <RouterLink
        :class="{
          '!bg-gray-250': location === handleFormattedRoute(menuItem?.route),
        }"
        :to="menuItem?.route"
        @click="hideSidebar(menuItem.action)"
        class="px-6 rounded-3xl transition-300 flex items-center group gap-3 h-12"
      >
        <i
          :class="[
            menuItem?.svgIcon,
            {
              'translate-x-[-12px]': !isOpen,
              '!text-dark': location === handleFormattedRoute(menuItem?.route),
            },
          ]"
          class="text-2xl text-gray-450 group-hover:!text-dark transition-300"
        />
        <div class="flex-y-center gap-3 w-full">
          <Transition name="fade" mode="in-out">
            <p
              v-show="isOpen"
              :class="[
                {
                  '!text-dark':
                    location === handleFormattedRoute(menuItem?.route),
                },
              ]"
              class="text-base text-gray-450 w-full !overflow-hidden group-hover:!text-dark font-semibold"
            >
              {{ $t(menuItem?.heading) }}
            </p>
          </Transition>
          <Transition name="fade" mode="in-out">
            <i
              v-show="isOpen"
              :class="[
                {
                  '!opacity-100 !visible':
                    location === handleFormattedRoute(menuItem?.route),
                },
              ]"
              class="icon-chevron-right text-base ml-auto text-dark opacity-0 invisible"
            />
          </Transition>
        </div>
      </RouterLink>
    </div>
  </div>
</template>

<script setup lang="ts">
import { menu, mobileMenu } from "@/data/menu";
import { useCommonStore } from "@/modules/Pages/stores";
import { useMobile } from "@/composables/useMobile";
import { computed } from "vue";
import { useAuthStore } from "@/modules/Auth/stores";
import { useI18n } from "vue-i18n";
import { useLocalizedNavigation } from "@/composables/useLocalizedNavigation";

interface Menu {
  location: string;
  isOpen: boolean;
}
defineProps<Menu>();

const { locale } = useI18n();
const store = useAuthStore();
const commonStore = useCommonStore();
const { isMobile } = useMobile("mobile");
const { navigateTo } = useLocalizedNavigation();

const checkMobile = computed(() => (isMobile.value ? mobileMenu : menu));
const checkUserEmail = computed(() => checkMobile.value);

const handleFormattedRoute = (route: string) => {
  return `/${locale.value}${route}`;
};

const hideSidebar = (action: string) => {
  if (commonStore.isSidebarOpen && isMobile.value) {
    commonStore.isSidebarOpen = false;
  }
  if (action) {
    logout();
  }
};
function logout() {
  store?.logout();
  navigateTo({ name: "PAuthLogin" });
}
</script>

<style scoped></style>
